module.exports = __webpack_public_path__ + "img/on-button.3677842b.png";